import { __rest, __assign } from 'tslib';
import React from 'react';
import cn from 'classnames';
import { Content } from './Component.js';
import '../../../../shared/esm';
import '../../Context.js';
import '../../../../base-modal/esm';
import '../../ResponsiveContext.js';

var styles = {"content":"side-panel__content_o1sm3"};
require('./mobile.css');

var ContentMobile = function (_a) {
    var className = _a.className, restProps = __rest(_a, ["className"]);
    return (React.createElement(Content, __assign({ className: cn(className, styles.content) }, restProps)));
};

export { ContentMobile };
